export default __webpack_public_path__ + "static/media/bear-orange.7de962fe.svg";